// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';

const Check = styled<any, Theme>('td')`
  border-left: 1px solid ${props => props.theme.packageCompare.columnBorder};
  color: ${props => props.theme.list.listStyles.check.color};
  font-size: 2rem;
  width: 2.5rem;
`;

export default Check;
